/** Mirrors finance IncomeSource / ExpenseCategory. */
export const INCOME_SOURCES = [
  { value: 'invoice', label: 'Invoice' },
  { value: 'upwork', label: 'Upwork' },
  { value: 'other', label: 'Other' },
] as const;

export const EXPENSE_CATEGORIES = [
  { value: 'software', label: 'Software / SaaS' },
  { value: 'contractor', label: 'Contractor' },
  { value: 'office', label: 'Office' },
  { value: 'payroll', label: 'Payroll' },
  { value: 'tax', label: 'Tax' },
  { value: 'other', label: 'Other' },
] as const;

export const incomeSourceLabel = (s: string): string =>
  INCOME_SOURCES.find((x) => x.value === s)?.label ?? s;

export const expenseCategoryLabel = (s: string): string =>
  EXPENSE_CATEGORIES.find((x) => x.value === s)?.label ?? s;
